window.Vue = require('vue');

export class CompareService {

    constructor () {
        this._products = [];
        this._productsSkuMap = {};
    }

    /**
     * Set products in global variables
     * @param products
     * @private
     */
    _setProducts(products) {
        this._products = products;
        this.updateProductSkupMap(this._products);

        bus.$emit('compare:loaded', this._products);
    }

    /**
     * Update sku map
     * @param products
     */
    updateProductSkupMap(products) {
        let self = this;
        this._productsSkuMap = {};

        $.each(products, function (key, product) {
            self._productsSkuMap[product.Sku] = key;
        });
    }

    /**
     * Add a single product to product list
     * @param product
     */
    addProduct(product) {
        if (this._products.length === 10){
            return false;
        }

        bus.$emit('compare:loading');

        this._products.push(product);

        bus.$emit('compare:loaded', this._products);

        return true;
    }

    /**
     * Returns if the given sku exist in the list of products added to the compare bar
     * @return boolean
     */
    skuInCompare(sku) {
        return typeof this._productsSkuMap[sku] !== 'undefined';
    }

    /**
     * Get all products in session
     */
    getProducts () {
        bus.$emit('compare:loading');

        axios.get('/compare-data')
            .then(response => {
                this._setProducts(response.data);
            });
    }

    /**
     * Add product to session
     *
     * @param sku
     * @returns {boolean}
     */
    addToSession (sku){
        bus.$emit('compare:loading');
        axios.post('/compare-data/' + sku)
            .then(response => {
                this._setProducts(response.data);
            });
    }

    /**
     * Check if product exists and remove
     * @param sku
     */
    removeProduct (sku) {
        bus.$emit('compare:loading');

        if (!this.skuInCompare(sku)) {
            return;
        }

        bus.$emit('removeCompareItem', this._productsSkuMap[sku]);
        this.removeFromSession(sku);
    }

    /**
     * Remove product from session
     * @param sku
     */
    removeFromSession (sku) {
        axios.delete('/compare-data/' + sku)
            .then(response => {
                this._setProducts(response.data);
            });
    }

    /**
     *
     * @param products
     * @returns {null}
     */
    removeAllProducts(products){

        bus.$emit('compare:loading');
        if (!products){
            return null;
        }

        $.each(products, function (key, product) {
            axios.delete('/compare-data/' + product.Sku);
        });

        this._products = [];
        this._productsSkuMap = {};
        bus.$emit('compare:loaded', this._products);
    }
}
